import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EffectsModule } from "@ngrx/effects";
import { UiHelperModule } from "../../ui-helper";

import { MerchantEffects } from './merchant.effects';
import { MerchantActions } from './merchant.actions'
import { MerchantResolver, AccountListResolver, AccountEditResolver, AccountCreateResolver, BookingOfficeResolver,
	EmailConfigListResolver } from './merchant.resolver'



@NgModule({
	imports: [
		UiHelperModule,
		EffectsModule.forFeature([MerchantEffects])
	],
	providers: [
		MerchantResolver,
		AccountListResolver,
		AccountEditResolver,
		AccountCreateResolver,
		BookingOfficeResolver,
		EmailConfigListResolver,
		MerchantActions
	]
})
export class MerchantModule {
	constructor() {

	}
}



// WEBPACK FOOTER //
// ./src/app/components/merchants/merchant.module.ts